// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070647/js/" + chunkId + "." + {"44":"5ebb9e84","225":"e8d9175c","481":"ddb8ec0c","486":"fb0219be","770":"aa0f5eb2"}[chunkId] + ".0.6049342585413781.chunk.js";
};